import React from 'react';
import { motion } from 'framer-motion';
import { ArticleBlock } from './ArticleBlock';
import type { ArticleSection as ArticleSectionType } from '../../types/advertorial';
interface ArticleSectionProps {
  section: ArticleSectionType;
}
export function ArticleSection({
  section
}: ArticleSectionProps) {
  return <section id={section.id} className="scroll-mt-16 border-t border-white/[0.07] pt-10 first:border-0 first:pt-0 md:pt-12" data-id="element-37" data-mp="2z19dxbth0yhg">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.55,
      ease: 'easeOut'
    }} data-id="element-38" data-mp="341eyk81bpkq1">
        <p className="font-mono text-[9.5px] tracking-[0.22em] text-gold md:text-[10px] md:tracking-[0.24em]" data-id="element-39" data-mp="3hz3hvbfqsjsz">
          CAPÍTULO {section.index}
        </p>
        <h2 className="mt-2.5 flex items-start gap-2.5 font-serif text-[23px] font-semibold italic leading-tight text-ivory sm:text-[26px] md:mt-3 md:gap-3 md:text-[32px]" data-id="element-40" data-mp="1iniyxa0tcpt1">
          <span aria-hidden="true" className="mt-[8px] h-[19px] w-[3px] shrink-0 rounded-sm bg-gold md:mt-[13px] md:h-[22px]" data-id="element-41" data-mp="tazvtlv7gzi5" />
          {section.title}
        </h2>
      </motion.div>

      <div className="mt-6 space-y-5 md:mt-7 md:space-y-6" data-id="element-42" data-mp="ki61ch76ttjp">
        {section.blocks.map((block, i) => <ArticleBlock key={`${section.id}-${i}`} block={block} data-id="element-43" data-mp="fk4fxpmahi52" data-mpi={i} />)}
      </div>
    </section>;
}